import { urlWithParams } from '@marketplace-web/shared/utils'

export const MEMBER_PROFILE_URL = (id: string | number, closetPromotionPrecheckout?: boolean) =>
  urlWithParams(`/member/${id}`, { cp_precheckout: closetPromotionPrecheckout })
export const ITEM_URL = (id: number): string => `/items/${id}`
export const ROOT_URL = '/'
export const EDIT_FEEDBACK_URL = (userId: number, feedbackId: number) =>
  `/member/${userId}/feedback/${feedbackId}/edit`
export const FEEDBACK_URL = (feedbackId: number) => `/feedback/${feedbackId}`
export const NOTICE_AND_ACTION_FORM = '/help/notice_and_action_form'
